import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';

// Surfaces a yellow banner under the topbar when the signed-in user is
// running low on 2FA backup codes (≤3 remaining). One GET on mount; if the
// user dismisses it, we remember per-session via sessionStorage so it
// doesn't reappear on every navigation.
const DISMISS_KEY = 'rs:2fa-banner-dismissed';

const TwoFactorBanner = () => {
    const token = useSelector((s) => s.auth?.token);
    const [low, setLow] = useState(false);
    const [remaining, setRemaining] = useState(0);
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(DISMISS_KEY) === '1',
    );

    useEffect(() => {
        if (!token || dismissed) return;
        let cancelled = false;
        axios
            .get('/api/2fa/status', { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => {
                if (cancelled) return;
                setLow(!!r.data.backupCodesLow);
                setRemaining(r.data.backupCodesRemaining || 0);
            })
            .catch(() => { /* status is opportunistic; never block the shell */ });
        return () => { cancelled = true; };
    }, [token, dismissed]);

    if (!low || dismissed) return null;

    const dismiss = () => {
        sessionStorage.setItem(DISMISS_KEY, '1');
        setDismissed(true);
    };

    return (
        <div
            role="alert"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 16px',
                background: '#fff7e0',
                borderBottom: '1px solid #f0d97a',
                color: '#6b5410',
                fontSize: 13,
                fontWeight: 500,
            }}
        >
            <span style={{ fontSize: 16 }} aria-hidden="true">⚠</span>
            <span style={{ flex: 1 }}>
                You have <b>{remaining}</b> 2FA backup code{remaining === 1 ? '' : 's'} left.
                Generate a fresh batch before you run out — recovery without them needs an admin.
            </span>
            <Link
                to="/dashboard/settings"
                style={{
                    color: '#6b5410',
                    textDecoration: 'underline',
                    fontWeight: 600,
                }}
            >
                Open settings
            </Link>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Dismiss"
                style={{
                    background: 'transparent',
                    border: 0,
                    color: '#6b5410',
                    cursor: 'pointer',
                    fontSize: 16,
                    lineHeight: 1,
                    padding: '0 4px',
                }}
            >
                ×
            </button>
        </div>
    );
};

export default TwoFactorBanner;
